var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.77d21cf8718091aa102ff82bd424dd62.svg#k';
                    var viewUrl = 'sprites.77d21cf8718091aa102ff82bd424dd62.svg#view-k';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 15 16',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };